import { Fragment } from "react";
import { Route } from "react-router";
import { IngredientList } from "./IngredientsList";
import { CreateIngredientPage } from "./IngredientForm/CreateIngredient";
import { UpdateQuestionnaire } from "./IngredientForm/UpdateIngredient";
import { QuestionnaireUpdate } from "./IngredientDetails/Questionnaire/QuestionnaireUpdate";
import { IngredientPrimaryTabs } from "./IngredientDetails/IngredientPrimaryTabs";
import { CREATE, MODIFY, VIEW, VIEW_SSQ } from "src/context/FoodpilotContext";
import { IngredientScores } from "./IngredientDetails/IngredientScores";
import { Questionnaire } from "./IngredientDetails/Questionnaire/Questionnaire";
import { IngredientActivitiesData } from "./IngredientDetails/IngredientActivitiesData";
import { Informations } from "./IngredientDetails/Informations";
import { ScoreDetail } from "src/components/ScoreDetail/ScoreDetail";
import { DimensionTreeSwitch } from "src/components/ScoreDetail/Dimensions/DimensionTreeSwitch";
import { IngredientValueChain } from "./IngredientDetails/IngredientValueChain";
import {
    QuestionnaireSupplierGuard,
    IngredientActionProtection,
    IngredientScoreDetail,
    IngredientScoresContext,
    IngredientViewRedirect,
    QuestionnaireRedirect,
} from "./ingredientRouter.components";
import { RouteErrorPage } from "src/components/PageState/RouteErrorPage";

export const useIngredientRouter = () => {
    return (
        <Fragment>
            <Route path="ingredients" errorElement={<RouteErrorPage />}>
                <Route element={<IngredientActionProtection slug={VIEW} />}>
                    <Route index element={<IngredientList />} />
                </Route>

                <Route path={"new"} element={<IngredientActionProtection slug={CREATE} />}>
                    <Route element={<CreateIngredientPage />}>
                        <Route index />
                        <Route path={":startingPageId"} />
                    </Route>
                </Route>

                <Route path=":ingredientId" element={<IngredientScoresContext />}>
                    <Route path={"edit"} element={<IngredientActionProtection slug={MODIFY} />}>
                        <Route element={<UpdateQuestionnaire />}>
                            <Route index />
                            <Route path={":startingPageId"} />
                        </Route>
                    </Route>

                    <Route element={<IngredientActionProtection slug={VIEW} />}>
                        <Route index element={<IngredientViewRedirect />} />

                        <Route path="scores" element={<IngredientPrimaryTabs selectedSection="scores" />}>
                            <Route index element={<IngredientScores />} />

                            <Route path=":scoreId" element={<IngredientScoreDetail />}>
                                <Route index element={<ScoreDetail selectedTab={null} />} />
                                <Route path="distribution" element={<ScoreDetail selectedTab={"distribution"} />}>
                                    <Route index element={<DimensionTreeSwitch mode={"distribution"} />} />
                                </Route>
                            </Route>
                        </Route>

                        <Route element={<IngredientActionProtection slug={VIEW_SSQ} />}>
                            <Route
                                path={"questionnaire"}
                                element={<IngredientPrimaryTabs selectedSection={"questionnaire"} />}
                            >
                                <Route index element={<QuestionnaireRedirect />} />
                                <Route path="supplier/:supplierId" element={<QuestionnaireSupplierGuard />}>
                                    <Route index element={<Questionnaire />} />
                                </Route>
                            </Route>
                            <Route path="questionnaire/supplier/:supplierId" element={<QuestionnaireSupplierGuard />}>
                                <Route path="edit/:headingId" element={<QuestionnaireUpdate />} />
                            </Route>
                        </Route>

                        <Route path={"activities"}>
                            <Route element={<IngredientPrimaryTabs selectedSection={"activities"} />}>
                                <Route index element={<IngredientActivitiesData />} />
                            </Route>
                        </Route>

                        <Route path={"informations"}>
                            <Route element={<IngredientPrimaryTabs selectedSection={"informations"} />}>
                                <Route index element={<Informations />} />
                            </Route>
                        </Route>

                        <Route path={"value-chain"}>
                            <Route element={<IngredientPrimaryTabs selectedSection={"value-chain"} />}>
                                <Route index element={<IngredientValueChain />} />
                            </Route>
                        </Route>
                    </Route>
                </Route>
            </Route>
        </Fragment>
    );
};
